import React from "react";
import {PriceType} from "state/types";

export interface MedicationSummaryPriceElementProps {
    price: PriceType,
}

const MedicationSummaryPriceElement = ({price}: MedicationSummaryPriceElementProps) => {
    const currencySymbol = price.currencySymbol;
    const decimalSeparator = ".";
    const wholeValue = Math.floor(price.amount);
    const fractionalValue = (price.amount % 1).toFixed(2).substring(2);

    return (
        <>
            <pui-text class="currency-symbol" fontweight="normal" input={currencySymbol}/>
            <pui-text class="currency-whole-value" fontweight="normal" input={wholeValue}/>
            <pui-text class="currency-fractional-value" fontweight="normal" input={fractionalValue}/>
        </>)
}

export default MedicationSummaryPriceElement;
